// src/hooks/useNavigation.ts
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

// Rutas disponibles en el sistema
const availableRoutes = [
  "/dashboard",
  "/PendingPayment", 
  "/AdminConfigPage",
  "/PackagesPage",
  "/PetsPage",
  "/PetsPage/CreatePetPage",
  "/UnitSelectionPage",
  "/RoleSelectionPage",
  "/ApartmentSelectionPage",
  "/ChangePasswordPage",
  "/UserProfilePage",
  "/encomiendas",
  "/pqr",
  "/desperfectos",
  "/visitantes",
  "/visitantes/crear",
  "/mascotas-perdidas",
  "/vehiculos",
  "/tablero",
  "/apartamentos",
  "/zonas-comunes",
  "/asambleas"
];

export const useNavigation = () => {
  const navigate = useNavigate();

  const handleNavigation = async (path: string, label: string) => {
    // Verificar si la ruta está disponible
    const isAvailable = availableRoutes.includes(path);

    if (!isAvailable) {
      // Mostrar alerta de próximamente con SweetAlert2
      await Swal.fire({
        title: '🚧 Próximamente',
        html: `
          <div style="text-align: center;">
            <div style="font-size: 3rem; margin-bottom: 1rem;">🛠️</div>
            <p style="font-size: 1.1rem; color: #666; margin-bottom: 0.5rem;">
              La sección <strong>${label}</strong> está en desarrollo
            </p>
            <p style="font-size: 0.9rem; color: #888;">
              Pronto estará disponible para ti
            </p>
          </div>
        `,
        icon: 'info',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#3085d6',
        background: '#fefefe',
        backdrop: 'rgba(0,0,0,0.4)',
        showClass: {
          popup: 'animate__animated animate__fadeInDown animate__faster'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp animate__faster'
        },
        customClass: {
          popup: 'rounded-xl shadow-2xl',
          title: 'text-2xl font-bold text-gray-800',
          confirmButton: 'px-6 py-2 rounded-lg font-semibold'
        }
      });
      return false; // Indica que no se navegó
    }

    // Si la ruta está disponible, navegar normalmente
    navigate(path);
    return true; // Indica que se navegó exitosamente
  };

  return { handleNavigation };
};